









import { Component, Vue } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import {  QuerySupplierList, QueryUserVoucherList } from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { UserVoucherStatusFormat, UseTypeFormat } from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import HouseDescDialog from '@/views/house/HouseDescDialog.vue'

@Component({
  components: {
    VQuery,
    VTable,
    HouseDescDialog,
  },
})
export default class VoucherList extends Vue {
  private queryParam = {
    useType: 0,
    startRow: 1,
    limit: 10,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1

  private supplierOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    { title: '使用类别', param: 'useType' , type: 'select', selectData: constant.UseType},
    this.supplierQueryParam,
    { title: '提货卷名称', param: 'voucherName' },
    { title: '状态', param: 'status', type: 'select', selectData: constant.UserVoucherStatus },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    { title: '使用类别', param: 'useType', formatter: UseTypeFormat},
    { title: '用户编号', param: 'userNo',overflow:true},
    { title: '户主编号', param: 'houseCode' ,overflow:true,click: this.openHouseDesc },
    { title: '手机号', param: 'voucherModelNo' },
    { title: '模版编号', param: 'voucherModelNo' },
    { title: '提货卷名称', param: 'voucherName' },
    { title: '使用说明', param: 'voucherExplain', overflow: true},
    { title: '主标题', param: 'mainTitle'},
    { title: '副标题', param: 'viceTitle'},
    { title: '供应商简称', param: 'supplierSimpleName'},
    { title: '总数量', param: 'count'},
    { title: '已使用数量', param: 'useCount'},
    { title: '状态', param: 'status', formatter: UserVoucherStatusFormat},
    { title: '创建时间', param: 'createTime', formatter: DateFormat },
    
  ]

  public async created() {
    this.loadData()
    await this.loadSupplier()
  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  public openHouseDesc(houseCode: any){
    const d = this.$refs.houseDescDialog as HouseDescDialog
    d.open(houseCode)
  }
 

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)
    const result = await QueryUserVoucherList(param)
    this.tableTotal = result.total
    this.tableData = result.list
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }
  
}
